import React from "react";
import { css } from "emotion";
import moment from "moment";
import { Link, NavLink } from "react-router-dom";
import { firebase, SECONDARY_TEXT, PRIMARY_TEXT } from "../../constants";
import { Button, Text } from "../../components";
import PlusIcon from "react-feather/dist/icons/plus";

const SidebarLink = ({ to, children }) => {
  return (
    <NavLink
      to={to}
      className={css`
        position: relative;
        display: block;
        color: ${SECONDARY_TEXT};
      `}
      activeClassName={css`
        font-weight: bold;
        color: ${PRIMARY_TEXT};
        &::before {
          content: "";
          position: absolute;
          top: calc(50% - 3px);
          left: -16px;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: ${PRIMARY_TEXT};
        }
      `}
    >
      {children}
    </NavLink>
  );
};

const DashboardSidebar = ({ initialized, church }) => {
  return (
    <div
      className={css`
        z-index: 9001;
        position: relative;
        flex-shrink: 0;
        width: 300px;
        padding: 40px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-color: #f3f2f1;
        border-right: 1px solid #b1b1b1;
        @media (max-width: 1000px) {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          padding-bottom: 150px;
          transform: translateX(-300px);
        }
      `}
    >
      {initialized ? (
        church ? (
          <header>
            <Text serif italic>
              Welcome,
            </Text>
            <Text.H3>{church.name}</Text.H3>
          </header>
        ) : (
          <header>
            <Text.H4>Welcome to Vital Signs!</Text.H4>
          </header>
        )
      ) : (
        <div />
      )}
      {initialized && church && church.assessments && (
        <section
          className={css`
            margin: 50px 0 50px 36px;
            position: relative;
          `}
        >
          <img
            src="/icons/reports.svg"
            alt="Reports"
            style={{
              width: 36,
              height: 36,
              position: "absolute",
              left: -40,
              top: -10,
            }}
          />
          <Text.H5 uppercase tracked>
            Reports
          </Text.H5>
          <ul
            className={css`
              margin: 0;
              padding: 0;
              list-style: none;
              li {
                margin: 10px 0;
              }
              a {
                text-decoration: none;
              }
            `}
          >
            {Object.entries(church.assessments).map(([key, assessment]) => (
              <li key={key}>
                <SidebarLink to={`/dashboard/${key}`}>
                  {assessment.timeSubmitted ? (
                    <Text>
                      {moment(assessment.timeSubmitted).format("MMMM YYYY")}
                    </Text>
                  ) : (
                    <Text>
                      {moment(assessment.timeStarted).format("MMMM YYYY")}
                      &nbsp;
                      <Text italic normal style={{ display: "inline" }}>
                        (In Progress)
                      </Text>
                    </Text>
                  )}
                </SidebarLink>
              </li>
            ))}
            <li>
              <SidebarLink to="/dashboard/new">
                <Text
                  style={{
                    color: "#3DB2D3",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <PlusIcon size="1em" style={{ marginRight: 5 }} /> Take Again
                </Text>
              </SidebarLink>
            </li>
          </ul>
        </section>
      )}
      <footer>
        <Button kind="outline" onClick={() => firebase.auth().signOut()}>
          Sign Out
        </Button>
      </footer>
    </div>
  );
};

export default DashboardSidebar;



// WEBPACK FOOTER //
// ./src/screens/dash/DashboardSidebar.js